import type { Translations } from "../../types";
import { buildings } from "./buildings";
import { buildingDetail } from "./buildingDetail";
import { esg } from "./esg";
import { technical } from "./technical";
import { documents } from "./documents";
import { forms } from "./forms";
import { common } from "./common";
import { session } from "./session";
import { help } from "./help";
import { fireSafetyEmptyState } from "./fireSafetyEmptyState";
import { auth } from "./auth";
import { settings } from "./settings";
import { projects } from "./projects";
import { timeline } from "./timeline";
import { budget } from "./budget";
import { buildingUsers } from "./buildingUsers";
import { pm } from "./pm";
import { signing } from "./signing";
import { brief } from "./brief";
import { contacts } from "./contacts";
import { tools } from "./tools";
import { messages } from "./messages";
import { buildingDataSummary } from "./buildingDataSummary";
import { billing } from "./billing";
import { connectors } from "./connectors";
import { pageInfo } from "./pageInfo";

// English translations
const translations: Translations = {
  common: {
    ...common,
  },
  buildings,
  buildingDetail,
  esg,
  technical,
  documents,
  forms,
  session,
  help,
  fireSafetyEmptyState,
  auth,
  settings,
  projects,
  timeline,
  budget,
  buildingUsers,
  pm,
  signing,
  brief,
  contacts,
  tools,
  messages,
  buildingDataSummary,
  billing,
  connectors,
  pageInfo,
  // Add the SignUp translations
  signUp: {
    title: "Sign Up",
    description: "Create an account to get started",
    joinOrganization: "Join {organization}",
    checkingExistingOrganizations: "Checking for existing organisations…",
    creatingAccount: "Creating account…",
    email: "Email",
    password: "Password",
    firstName: "First Name",
    lastName: "Last Name",
    organizationName: "Organisation Name",
    organizationDomain: "Organisation Domain",
    terms: "I accept the terms and conditions",
    termsLink: "terms",
    submit: "Sign Up",
    alreadyHaveAccount: "Already have an account?",
    login: "Login",
    success: "Success",
    successDescription: "Account created successfully. You can now log in.",
    errorDescription: "Error creating account. Please try again.",
    cleanupNoticeTitle: "Account Cleanup",
    cleanupNoticeDescription:
      "We found an incomplete account setup and cleaned it up. You can now sign up again.",
    invalidInviteMessage: "The invitation link is invalid or has expired.",
  },
  // Legacy field mappings
  buildingSections: buildings.buildingSections,
  finishes: buildings.finishes,
  structuralMaterials: buildings.structuralMaterials,
  fireSafety: buildings.fireSafety,
  roomsSection: buildings.roomsSection,
};

export default translations;
export const en = translations;
